<div class="fpui-tab-wrapper"><div class="fpui-tab-content" :id="customId"><slot></slot></div></div>